import { Trans } from "@lingui/macro";

const EmptyEntries = () => (
  <div className="flex items-center justify-center h-40">
    <Trans>No entries for this date</Trans>
  </div>
);

export default EmptyEntries;
